<template>
  <div>
    <img class='d-none d-xl-block' src="../assets/images/travel-medi-banner.png" style='margin-left: 100px; float:right;'/>
    <div class='row no-gutters'>
      <div class='col-12'>
        <div v-if='this.$store.state.site==="cibc"'>
          <div v-if="this.$store.state.fulfillment==='mail'" style='font-weight:bold;' class='textInstructions col-12' v-html="$t('text.page13_thankyou')+' '+$t('text.page13_mail')"></div>
          <div v-if="this.$store.state.fulfillment==='email'" style='font-weight:bold;' class='textInstructions col-12' v-html="$t('text.page13_thankyou')+' '+$t('text.page13_email')"></div>
          <div v-if="this.$store.state.fulfillment==='both'" style='font-weight:bold;' class='textInstructions col-12' v-html="$t('text.page13_thankyou')+' '+$t('text.page13_both')"></div>

        </div>
        <div v-else>
          <div v-if="this.$store.state.fulfillment==='mail'" style='font-weight:bold;' class='textInstructions col-12' v-html="$t('text.page13_thankyounm')+' '+$t('text.page13_mail')"></div>
          <div v-if="this.$store.state.fulfillment==='email'" style='font-weight:bold;' class='textInstructions col-12' v-html="$t('text.page13_thankyounm')+' '+$t('text.page13_email')"></div>
          <div v-if="this.$store.state.fulfillment==='both'" style='font-weight:bold;' class='textInstructions col-12' v-html="$t('text.page13_thankyounm')+' '+$t('text.page13_both')"></div>
        </div>
      </div>
    </div>      
    <div class='orderRow row no-gutters'>
      <div class='col-12'><h2 class='orderFieldTitle'>{{$t('text.page13_field1')}}</h2></div>
      <div class='col-12 orderFields'>{{startDate}} {{$t('text.to')}} {{endDate}}</div>
    </div>
    <div class='orderRow row no-gutters'>
      <div class='col-12'><h2 class='orderFieldTitle'>{{this.$store.state.product.Product.Name}}</h2></div>
      <div class='col-12 orderFields'>{{benefits}}</div>
    </div>
    <div class='orderRow row no-gutters'>
      <div class='col-12'><h2 class='orderFieldTitle'>{{$t('text.insured')}}</h2></div>
      <div class='col-12 orderFields'>{{this.$store.state.traveller1_firstname}} {{this.$store.state.traveller1_lastname}} - {{this.$store.state.traveller1_dob}}</div>
    </div>
    <div class='orderRow row no-gutters'>
      <div class='col-12'><h2 class='orderFieldTitle'>{{$t('text.page13_field2')}}</h2></div>
      <div class='col-12 orderCCDetails' v-html="$t('text.page13_field3')+' '+cardholderName"></div>
      <div class='col-12 orderCCDetails' v-html="$t('text.page13_field4')+' '+creditcard"></div>
      <div class='col-12 orderCCDetails' v-html="$t('text.page13_field5')+' '+this.$moment().format('MM/DD/YYYY')"></div>
      <div class='col-12 orderCCDetails' v-html="$t('text.page13_field6')+' '+totalAmount"></div>
    </div>
    <div class='orderRow row no-gutters' style='border:0px; margin-bottom: 0px; padding:0px;'>
      <div class='col-12'>
        <h2 v-if='this.$store.state.site==="cibc"' class='orderFieldTitle'>{{$t('text.page13_field7')}}</h2>
        <h2 v-else class='orderFieldTitle'>{{$t('text.page13_field7nm')}}</h2>
      </div>
      <div class='col-12 orderFields'>{{this.$store.state.policyNumber}}</div>
    </div>
    <div id='nav_printconfirmation' class='row' style='margin-top: 25px; margin-bottom:25px; '>
      <button @click="printPage()" class='btn btn-primary d-print-none' style='margin-left:35px; min-width: 200px;'>{{$t('text.page13_print')}}</button>
    </div>
    <div class='orderRow row no-gutters'>
      <div v-if='this.$store.state.site==="cibc"' v-html="$t('text.page10_eventofemergency')"> </div>
      <div v-else v-html="$t('text.page10_eventofemergencynm')"></div>
    </div>
    <div class ='orderRow row no-gutters d-print-none'>
      <div class='col-12'>
        <h2 v-if='this.$store.state.site==="cibc"' class='orderFieldTitle'>{{$t('text.page13_interested')}}</h2>
        <h2 v-else class='orderFieldTitle'>{{$t('text.page13_interestednm')}}</h2>
      </div>
      <div class='col-12'>
        <a href="javascript:void(0);" @click='newQuote()'>{{$t('text.page13_requestanother')}}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    benefits: {
      get(){ 
        let benefitText="";
        for(const benefit in this.$store.state.product.Product.BenefitsDetails) {
          if (benefit!=="0"){
            benefitText=benefitText+", ";
          }
          benefitText=benefitText+this.$store.state.product.Product.BenefitsDetails[benefit];
        }
        return benefitText;
      }
    },
    startDate: {
      get(){
        let startDateText = "";
        if(this.$store.state.product.Product.ProductCode==="CIBCAnnual8Day"||
        this.$store.state.product.Product.ProductCode==="CIBCAnnual18Day"||
        this.$store.state.product.Product.ProductCode==="CIBCIAnnual8Day"||
        this.$store.state.product.Product.ProductCode==="CIBCIAnnual18Day"){
          startDateText= this.$moment(this.$store.state.tripStart, "MM/DD/YYYY").format("MMMM Do, YYYY");
        } else {
          startDateText= this.$moment(this.$store.state.departureDate, "MM/DD/YYYY").format("MMMM Do, YYYY");
        }
        // Can't get moment locale working, manually replacing month names.
        if(this.$i18n.locale==="fr"){
          startDateText=startDateText.replace(/January/g,"janvier");
          startDateText=startDateText.replace(/February/g,"février");
          startDateText=startDateText.replace(/March/g,"mars");
          startDateText=startDateText.replace(/April/g,"avril");
          startDateText=startDateText.replace(/May/g,"mai");
          startDateText=startDateText.replace(/June/g,"juin");
          startDateText=startDateText.replace(/July/g,"juillet");
          startDateText=startDateText.replace(/August/g,"aout");
          startDateText=startDateText.replace(/September/g,"septembre");
          startDateText=startDateText.replace(/October/g,"octobre");
          startDateText=startDateText.replace(/November/g,"novembre");
          startDateText=startDateText.replace(/December/g,"décembre");
        }
        return startDateText;
      }
    },
    endDate: {
      get(){
        let endDateText= "";
        if(this.$store.state.product.Product.ProductCode==="CIBCAnnual8Day"||
          this.$store.state.product.Product.ProductCode==="CIBCAnnual18Day"||
          this.$store.state.product.Product.ProductCode==="CIBCIAnnual8Day"||
          this.$store.state.product.Product.ProductCode==="CIBCIAnnual18Day"){
          endDateText = this.$moment(this.$store.state.tripStart, "MM/DD/YYYY").add(1, "years").subtract(1,"day").format("MMMM Do, YYYY");
        } else {
          endDateText = this.$moment(this.$store.state.returnDate, "MM/DD/YYYY").format("MMMM Do, YYYY");
        }
        // Can't get moment locale working, manually replacing month names.
        if(this.$i18n.locale==="fr"){
          endDateText=endDateText.replace(/January/g,"janvier");
          endDateText=endDateText.replace(/February/g,"février");
          endDateText=endDateText.replace(/March/g,"mars");
          endDateText=endDateText.replace(/April/g,"avril");
          endDateText=endDateText.replace(/May/g,"mai");
          endDateText=endDateText.replace(/June/g,"juin");
          endDateText=endDateText.replace(/July/g,"juillet");
          endDateText=endDateText.replace(/August/g,"aout");
          endDateText=endDateText.replace(/September/g,"septembre");
          endDateText=endDateText.replace(/October/g,"octobre");
          endDateText=endDateText.replace(/November/g,"novembre");
          endDateText=endDateText.replace(/December/g,"décembre");
        }
        return endDateText;
      }
    },
    cardholderName: {
      get() { 
        return this.$store.state.creditcard_name;
      }
    },
    creditcard: {
      get() {
        return "**** **** **** "+this.$store.state.creditcard.substr(this.$store.state.creditcard.length - 4);
      }
    },
    totalAmount: {
      get() {
        let price = Number(this.$store.state.product.Total);
        const res = String(this.$store.state.product.Total).split(".");
        if(res.length === 1 || res[1].length < 3) {
          price = price.toFixed(2);
        }
        return "$"+price;
      }
    }
  },
  methods: {
    newQuote() {
        let pathInsert="";
        const pathArray=window.location.pathname.split("/");
        if(pathArray[1]==="cibc"||pathArray[2]==="cibc") { pathInsert="/cibc";}
        else if(pathArray[1]==="cibcinsurance"||pathArray[2]==="cibcinsurance"){ pathInsert="/cibcinsurance";}
        window.location.href=window.location.origin + pathInsert;
    },
    printPage() {
      window.print();
    }
  },
  mounted(){
    // Focus stepTitle for accessibility.
    this.$nextTick( () => {
      document.getElementById("stepTitle").focus();
    });
  }
}
</script>

<style>
.orderRow {
  margin-left: 20px;
  border-bottom:1px solid #CCCCCC;
  color: #333333;
  padding-bottom:25px;
  margin-bottom: 25px;
}
.orderFieldTitle {
  font-size: 20px;
  line-height: 30px;
}
.orderCCDetails {
  font-weight: 600;
  margin-top:15px;
}
</style>
